import { useState } from "react";
import { BsCalendar2Check } from "react-icons/bs";
import ExpandPanel from "./ExpandPanel";

export default function HandledWidget({ bookings }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const data = bookings.filter(
    (item: any) => item.wip !== undefined && item?.is_confirmed
  );


  const all = bookings?.length;
  const filtered = data?.length;

  const percentage = (filtered / all) * 100;

  return (
    <div className="col-span-12 sm:col-span-3 border px-4 py-2 flex items-center bg-white hover:bg-red-50">
      <button className="flex w-full" onClick={() => setVisible(true)}>
        <div className="flex justify-center items-center rounded-lg border h-12 w-12 bg-red-100">
          <BsCalendar2Check size={24} />
        </div>
        <div className="border-l ml-2">
          <div className="pl-4 ">Handled Bookings</div>
          <div className="pl-4 text-xl text-black flex items-center">
            <span className="font-bold">{data?.length}</span>
            <span className="text-xs ml-2 mt-1 italic">
              ( {isNaN(percentage) ? 0 : Math.round(percentage)} % )
            </span>
          </div>
        </div>
      </button>
      <ExpandPanel
        isVisible={isVisible}
        setVisible={setVisible}
        data={data}
        title={"Handled Bookings"}
      />
    </div>
  );
}
